// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { deleteLoop } from '@automator/builder/services/item/loop';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-loop-menu-button-delete' )
export class AutomatorBuilderLoopMenuButtonDelete extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties

	// The item ID (post ID)
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				@click=${ this.handleLoopDelete }
			>
				${ escapeHTML( __( 'Delete', 'uncanny-automator' ) ) }
			</uo-button>
		`;
	}

	/**
	 * Handles the loop deletion
	 */
	handleLoopDelete() {
		deleteLoop(
			this.loopID
		);
	}
}
